import React from 'react';
import { styled } from '@linaria/react';
import { CarouselWidgets } from 'components/CarouselWidgets';
const Wrapper = /*#__PURE__*/styled('section')({
  name: "Wrapper",
  class: "w1vkuxuy",
  propsAsIs: false
});
interface Props {
  hasContext?: boolean;
}
export const WidgetsSection: React.FC<Props> = ({
  hasContext
}) => {
  return <Wrapper>
      <CarouselWidgets hasContext={hasContext} space="s900" />
    </Wrapper>;
};

require("./WidgetsSection.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./WidgetsSection.tsx");